import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from './services/shared.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'angular_aqb2';
  toast: any = {};
  confirm: any = {};
  alert: any = {};
  win = window as any;
  iconType: any = {
    success: 'bi-check2-circle',
    error: 'bi-exclamation-octagon',
    warning: 'bi-exclamation-triangle',
    info: 'bi-info-circle',
    danger: 'bi-exclamation-octagon',
  }
  loaded = false;
  constructor(
    public sharedService: SharedService,
    private translate: TranslateService,
    private router: Router
  ) { }
  public throwTestError(): void {
    throw new Error("Sentry Test Error");
  }
  message: any = "";
  messageBox(e: any) {
    let divToast = document.querySelector('.toastClone');
    let divToastList = document.querySelector('.toast-list');
    if (divToast && divToastList) {
      let divClone = divToast.cloneNode(true) as any;
      divClone.classList.remove('toastClone');
      divClone.classList.add('show');
      divClone.querySelector('.content').innerHTML = e.message;
      if (!e.title) {
        divClone.querySelector('.title').classList.add('d-none');
      } else {
        divClone.querySelector('.title').innerHTML = e.title;
      }
      divClone.querySelector('.bg').classList.add(e.type);
      divClone.querySelector('.bg').classList.add('show');
      divClone.querySelector('.icon').classList.add(this.iconType[e.type]);
      if (e.link) {
        divClone.addEventListener('click', (event: any) => {
          console.log('link', e.link);
          this.router.navigate([e.link]);
        });
      }
      divToastList.appendChild(divClone);
      if (e.delay) {
        setTimeout(() => {
          divClone.classList.remove('show');
          divClone.querySelector('.bg').classList.remove('show');
          setTimeout(() => {
            divClone.remove();
          }, 500);
        }, e.delay);
      }
    }
  }
  async ngOnInit() {
    await this.sharedService.loadModels();
    this.loaded = true;
    this.translate.onLangChange.subscribe((event: any) => {
      console.log(this.translate.currentLang);
    });
    this.sharedService.Toast.subscribe((e: any) => {
      if (!e || !e.message) return;
      e.delay = e.delay ? e.delay : 3000;
      this.messageBox(e);
    });
    this.sharedService.Confirm.subscribe((e: any) => {
      if (!e) return;
      this.confirm.message = e.message ?? e;
      this.confirm.title = e.title ?? 'Confirm';
      let divConfirm = document.querySelector('#confirmModal');
      let confirm = new this.win.bootstrap.Modal(divConfirm);
      confirm.show();
    });
    this.sharedService.Alert.subscribe((e: any) => {
      if (!e) return;
      this.alert.title = e.title ?? 'Alert';
      this.alert.message = e.message;
      let divAlert = document.querySelector('#alert');
      let alert = new this.win.bootstrap.Modal(divAlert);
      alert.show();
    });
  }
  onConfirm(e: boolean) {
    this.sharedService.onConfirm.next(e);
  }
}
